import jwtDecode from 'jwt-decode';

interface JwtToken {
  sub: string;
  name: string;
  admin?: boolean;
  iat?: number;
  exp?: number;
  [key: string]: unknown;
}

const isBrowser = (): boolean =>
  typeof window !== 'undefined' && typeof localStorage !== 'undefined';

// ----------------------------------------------------------------------

const removeTokensMetadata = (): void => {
  if (!isBrowser()) {
    return;
  }
  cleanupOldTokens();
  cleanupTokens();
  window.location.href = '/';
};

const setSessionTokenDetails = (
  accessToken: string,
  refreshToken: string
): void => {
  if (!isBrowser()) {
    return;
  }
  cleanupOldTokens();
  setTokenMetadataInLocalStorage(accessToken, 'accessTokenMetadata');
  setTokenMetadataInLocalStorage(refreshToken, 'refreshTokenMetadata');
};

// TODO - Remove this function in the future
const cleanupOldTokens = (): void => {
  if (!isBrowser()) {
    return;
  }
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refresh');
};

// TODO - Remove this function in the future
const removeUserPilotFromLocalStorage = (): void => {
  if (import.meta.env.VITE_USERPILOT_KEY) {
    return;
  }
  if (!isBrowser()) {
    return;
  }
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);

    if (key?.startsWith('userpilot')) {
      localStorage.removeItem(key);
    }
  }
};

const cleanupTokens = (): void => {
  if (!isBrowser()) {
    return;
  }
  localStorage.removeItem('accessTokenMetadata');
  localStorage.removeItem('refreshTokenMetadata');
};

const setTokenMetadataInLocalStorage = (token: string, key: string): void => {
  if (!token || !isBrowser()) {
    return;
  }
  const decodedToken = jwtDecode(token) as JwtToken;
  const tokenData = {
    exp: decodedToken.exp,
    iat: decodedToken.iat,
  };
  localStorage.setItem(key, JSON.stringify(tokenData));
};

const isTokenMetaValid = (metaKey: string): boolean => {
  if (!isBrowser()) {
    return false;
  }
  const tokenMetadata = localStorage.getItem(metaKey);
  if (!tokenMetadata) {
    return false;
  }
  const decodedToken = JSON.parse(tokenMetadata);
  const currentTime = Date.now() / 1000;
  return decodedToken.exp > currentTime;
};

export {
  setSessionTokenDetails,
  removeTokensMetadata,
  removeUserPilotFromLocalStorage,
  cleanupTokens,
  isTokenMetaValid,
  setTokenMetadataInLocalStorage,
};
